import { useMutation } from "@tanstack/react-query";
import { http } from "../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../consts/api";

export const useAcknowledgeAll = (options = {}) => {
  return useMutation(({ patient_id }) => {
    return http.post(HTTP_ENDPOINTS.stickyNotes.setAcknowledgeAll(patient_id));
  }, options);
};
